import type { CommunityMemberSelectCompassComponentProps } from "./CommunityMemberSelectCompassComponent";
import { CommunityMemberSelectCompassComponent } from "./CommunityMemberSelectCompassComponent";

// eslint-disable-next-line no-barrel-files/no-barrel-files -- Public API surface for CommunityMemberSelectCompass
export type { CommunityMemberSelectCompassComponentProps };
// eslint-disable-next-line no-barrel-files/no-barrel-files -- Public API surface for selected member details
export type { SelectedCommunityMember } from "./useCommunityMemberSelectOptions";

export const CommunityMemberSelectCompass =
  CommunityMemberSelectCompassComponent;
